import { cva } from "class-variance-authority";

const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default: "dark:bg-primary dark:text-white dark:hover:bg-primary/90 bg-primary text-white hover:bg-primary/90",
        destructive:
          "dark:bg-destructive dark:text-destructive-foreground dark:hover:bg-destructive/90 bg-destructive text-destructive-foreground hover:bg-destructive/90",
        outline:
          "border border-input hover:bg-accent hover:text-accent-foreground data-[active=true]:bg-primary data-[active=true]:text-primary-foreground data-[active=true]:border-primary dark:border-border dark:text-foreground dark:hover:bg-accent dark:hover:text-accent-foreground dark:data-[active=true]:bg-primary dark:data-[active=true]:text-primary-foreground dark:data-[active=true]:border-primary",
        secondary:
          "bg-primary text-primary-foreground hover:bg-primary/80 dark:bg-primary dark:text-primary-foreground dark:hover:bg-primary/80",
        ghost: "hover:ghost-hover-gradient",
        link: "dark:text-primary dark:underline-offset-4 dark:hover:underline text-primary underline-offset-4 hover:underline",
      },
      size: {
        default: "h-10 px-4 py-2 text-sm",
        sm: "h-8 rounded-md px-2 text-xs",
        lg: "h-12 rounded-md px-6 text-sm",
        icon: "h-8 w-8",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
);

export { buttonVariants };
